import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import trackEvent from 'utils/analytics';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function useTrackProductViewed() {
  const query = useQuery();
  useEffect(() => {
    trackEvent.productViewed({
      referringLink: query.get('refLink'),
    });
  }, []);
}
